import { IState } from 'shared/store';

export const selectBestPlaceReportModalOpened = (state: IState) => {
  return state.bestPlaceModal.isOpened;
};
